import React, { useState, useEffect, lazy, Suspense } from 'react';
import { MainContentContainer } from '../Routes/OtherPages.styles';
import {
  CourseContainer,
  OnlineCoursesContainer,
  SearchContainer,
  SearchBarContainer,
} from './TrainingStyles.styles';
import LoadingOnlineTraining from '../Components/LoadingPages/LoadingOnlineTraining.component';
import CoursesDataProvider from '../Utils/Courses/CoursesDataProvider';
import HelmetHelper from '../Components/PageHelmet/HelmetHelper.component';
const CourseCardSingle = lazy(() => import('./CourseCardComponent.component'));
const SlidingTagMenu = lazy(() => import('./SlidingTagMenu.component'));
// import ErrorMessage from '../Components/ErrorPage/Error.component';

const PageScroller = lazy(
  () => import('../Components/PageScroller/PageScroller.component')
);
const SideContainerComponent = lazy(
  () => import('../Routes/SideContainer.component')
);
// const PrimaryButton = lazy(
//   () => import('../Components/Buttons/PrimaryButton/PrimaryButton.component')
// );
import FilterIcon from '../Visuals/Icons/FilterIcon.icon';
import EntityLoader from '../Components/LoadingPages/LoadingEntity.component';

const OnlineTraining = () => {
  const [allCourses, setAllCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedTag, setSelectedTag] = useState('all');
  const [isOpen, setIsOpen] = useState(false);
  const [searching, setSearching] = useState('');

  useEffect(() => {
    setIsLoading(true);
    let filtered = allCourses;
    if (selectedTag !== 'all') {
      filtered = filtered?.filter((course) =>
        course.tags?.includes(selectedTag)
      );
    }
    if (searching.trim() !== '') {
      filtered = filtered.filter((course) =>
        course?.courseName?.toLowerCase()?.includes(searching?.toLowerCase())
      );
    }
    setFilteredCourses(filtered);
    setIsLoading(false);
  }, [searching, selectedTag, allCourses]);

  return (
    <MainContentContainer>
      <HelmetHelper
        title="Online Training"
        description="Online training for yoda safety services"
      />
      <Suspense fallback={<LoadingOnlineTraining />}>
        <SideContainerComponent />
        <CoursesDataProvider>
          {(courses) => {
            if (allCourses.length === 0 && courses) {
              setAllCourses(courses);
              setFilteredCourses(courses);
              setIsLoading(false);
            }
            return (
              <OnlineCoursesContainer>
                <SearchContainer>
                  <h2>Online Training</h2>
                  <SearchBarContainer>
                    <input
                      type="text"
                      onChange={(e) => setSearching(e.target.value)}
                      value={searching}
                      placeholder="Search for a course"
                      required
                      name="searching"
                    />
                    {/* <PrimaryButton functionName={() => {}} span="Search" /> */}
                    <FilterIcon functionName={() => setIsOpen(!isOpen)} />
                  </SearchBarContainer>
                </SearchContainer>
                <Suspense fallback={<EntityLoader />}>
                  <CourseContainer>
                    {isLoading ? (
                      <EntityLoader />
                    ) : filteredCourses.length > 0 ? (
                      filteredCourses.map((c) => (
                        <CourseCardSingle key={c._id} c={c} />
                      ))
                    ) : (
                      <p>No courses found</p>
                    )}
                  </CourseContainer>
                </Suspense>
                <PageScroller />
                <SlidingTagMenu
                  isOpen={isOpen}
                  onClose={() => setIsOpen(false)}
                  tagChange={(tag) => setSelectedTag(tag)}
                  selectedTag={selectedTag}
                  setSelectedTag={setSelectedTag}
                />
              </OnlineCoursesContainer>
            );
          }}
        </CoursesDataProvider>
      </Suspense>
    </MainContentContainer>
  );
};

export default OnlineTraining;
